import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import * as  EmailActionSlice from '../../../../../../slices/EmailActionSlice';
import { useReduxDispatch } from '../../../../../../redux/hooks';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { UserApi } from '../../../../../../redux/api/UserApi';

interface ConfirmCloseProps {
    ticketId: number;
    visible: boolean;
    onClose: () => void;
    onDiscard: () => void;
}

const ConfirmClose: React.FC<ConfirmCloseProps> = ({ ticketId, visible, onClose, onDiscard }) => {
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const { data: defaultFormState, isLoading } = TicketApi.useGetEmailConfigQuery(ticketId, { skip: userProfile?.Features?.External_Interface });
    const dispatch = useReduxDispatch();
    //Reset the form to the default state
    const discardChanges = () => {
        dispatch(EmailActionSlice.resetForm(defaultFormState));
        if (onDiscard) onDiscard();
    }

    return (
        <div>
            {visible && (
                <Dialog className='cool-window' title="Confirm Close" onClose={onClose}>
                    <p>Are you sure you want to close and lose any changes?</p>
                    <DialogActionsBar layout='center'>
                        <Button size='large' themeColor={'primary'} onClick={discardChanges}>Close</Button>
                        <Button size='large' fillMode='outline' onClick={onClose}>Cancel</Button>
                    </DialogActionsBar>
                </Dialog>
            )}
        </div>
    );
};

export default ConfirmClose;